import Search from '.';
import Translator from '../../../../utils/translation/Translator';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ClientAddSearch extends Component {
  static propTypes = {
    ClientAddSearchConfig: PropTypes.shape({
      searchFilters: PropTypes.array.isRequired,
      searchType: PropTypes.string.isRequired,
      limit: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
    }).isRequired,
    dictionary: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    associates: PropTypes.arrayOf(
      PropTypes.shape({
        associateId: PropTypes.string,
        clientId: PropTypes.string,
        isNexoClient: PropTypes.bool,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        isCurrentlySelectedAssociate: PropTypes.bool,
        isPersonalAssociate: PropTypes.bool,
        client: PropTypes.object, // eslint-disable-line react/forbid-prop-types
      }).isRequired
    ).isRequired,
    allClientAccessRoles: PropTypes.arrayOf(
      PropTypes.shape({
        role: PropTypes.string,
        ticketUrl: PropTypes.string,
      }).isRequired
    ).isRequired,
  };

  render() {
    const { ClientAddSearchConfig, dictionary } = this.props;
    const switchClientDictionary = new Translator('ACCOUNT_SETTINGS.SWITCH_CLIENT');
    const { searchFilters, searchType, limit } = ClientAddSearchConfig;

    return (
      <Search
        {...this.props}
        title={switchClientDictionary.get('SEARCH_TITLE', dictionary)}
        searchType={searchType}
        searchFilters={searchFilters}
        limit={limit}
      />
    );
  }
}

export default ClientAddSearch;
